import Modal from '../Modal';
import { useFm } from '@web3/base-hooks';

export function InstallBybitWallet(props: {
  visible: boolean;
  onOK: () => void;
  onCancel: () => void;
}) {
  const fm = useFm();

  return (
    <Modal
      visible={props.visible}
      size="small"
      title=""
      type="alert"
      onOk={props.onOK}
      okText={fm('installBybitWalletExt')}
      cancelText={false}
      onCancel={props.onCancel}
    >
      <div className="text-center">
        <p className="mt-4 text-lg font-semibold">
          {fm('eventSupportsBybitWalletExt')}
        </p>
        <p className="text-gray1 text-sm font-normal mt-2">
          {fm('ensureBybitWalletExt')}
        </p>
      </div>
    </Modal>
  );
}
